import Provider from './src/contexts/app-context';

export const wrapRootElement = Provider;